import { render } from "./CopyDayModal.vue?vue&type=template&id=b65e85fe&scoped=true&ts=true"
import script from "./CopyDayModal.vue?vue&type=script&lang=ts"
export * from "./CopyDayModal.vue?vue&type=script&lang=ts"

import "./CopyDayModal.vue?vue&type=style&index=0&id=b65e85fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65e85fe"]])

export default __exports__